import React from 'react'
import { Button } from '@mui/material';
import Card from '@mui/joy/Card';
import CardContent from '@mui/joy/CardContent';
import Typography from '@mui/joy/Typography';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { useState } from 'react';
import CheckIcon from '@mui/icons-material/Check';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import ClearIcon from '@mui/icons-material/Clear';
import "../ContentSeo/TitleDivSeo.css"

function HaveIconOrNot(props) {



    const [open, setOpen] = useState(false);
    const handleClickOpen = () => {
        setOpen(true);
      };
    
      const handleClose = (e) => {
        setOpen(false);
      }



  return (
    <div id={`section-${props.index}`}>
      <div style={{marginTop:"10px"}} className='TitleDivSeo' onClick={handleClickOpen}>
      <div className="CARD" onClick={handleClickOpen}>
       <div
        style={{
          background: 'linear-gradient(to right, #ffcc00, #ff9900)', // Use your preferred background style
          padding: '10px',
          borderRadius:"5px",
          opacity:"0.6",
          color:"white"
        }}
      >
        <h3>فحص عناوين ال URLS</h3>
      </div>
       <Card orientation="horizontal" variant="outlined" sx={{ width: "100%",textAlign:"right"}}>
      <CardContent>
        <Typography fontWeight="md" textColor="success.plainColor">
            {props.faviconUrl ? " جيد موقع الويب الخاص بك يحتوي على FAVICON"  : 
            "أوبس ليس لديك FavIcon خاصة بموقعك"}
           
        </Typography>
        {props.faviconUrl ? <>
            <Typography fontWeight="md" level="body-sm">
  <p style={{ display: "flex", alignItems: "center" }}>
    الأيكونة الخاصة بموقعك 
    <img style={{ marginRight: "5px", width: "30px", height: "30px", borderRadius: "20px", verticalAlign: "text-top" }} src={props.faviconUrl} alt="favIcon" />
  </p>
</Typography>
        </> :null}

      </CardContent>
      { props.faviconUrl ?
  <CheckIcon style={{ color: "#27ae60", fontSize: "50px" }} /> : 
  <PriorityHighIcon style={{ color: "#f39c12",fontSize: "50px" }} /> }
    </Card>
    </div>
    <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent style={{direction:"rtl"}}>
          <DialogContentText id="alert-dialog-description" style={{color:"rgb(78, 181, 76)"}}>
          تعمل الأيقونات المفضلة على تحسين رؤية العلامة التجارية.
نظرا لأن الرمز المفضل مهم بشكل خاص للمستخدمين الذين يضعون إشارة مرجعية على موقع الويب الخاص بك ، تأكد من توافقه مع علامتك التجارية.
          </DialogContentText>
        </DialogContent>
        <Button onClick={(e) => { e.stopPropagation(); handleClose(); }}>close</Button>
      </Dialog>
    </div>
    </div>
  )
}
export default HaveIconOrNot